import React, { useState } from 'react';
import { Box, TextField, Button, Typography, Paper, Alert, CircularProgress } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import axios from 'axios';

export default function LoginPage({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPass, setShowPass] = useState(false);
  const [totpCode, setTotpCode] = useState('');
  const [need2fa, setNeed2fa] = useState(false);
  const [twoFaError, setTwoFaError] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async () => {
    setLoading(true);
    setError('');
    try {
      const form = new FormData();
      form.append('username', username);
      form.append('password', password);
      if (totpCode) form.append('totp_code', totpCode);
      const res = await axios.post('/token', form);
      localStorage.setItem('dashboard_token', res.data.access_token);
      onLogin(res.data.access_token);
    } catch (e) {
      if (e.response?.status === 428) {
        setNeed2fa(true);
        setError('');
      } else if (e.response?.status === 401 && need2fa) {
        setError('❌ Невірний код 2FA');
      } else {
        setError('Невірний логін або пароль');
      }
    }
    setLoading(false);
  };

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', bgcolor: '#0f0f1a' }}>
      <Paper sx={{ p: 4, width: 360, bgcolor: '#1a1a2e', border: '1px solid #333', borderRadius: 3 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 3 }}>
          <Box sx={{ bgcolor: 'var(--ac1, #7c4dff)', borderRadius: '50%', p: 1.5, mb: 2 }}>
            <LockIcon sx={{ color: '#fff', fontSize: 32 }}/>
          </Box>
          <Typography variant="h5" sx={{ color: '#fff', fontWeight: 'bold' }}>Media Bot</Typography>
          <Typography variant="body2" sx={{ color: '#aaa' }}>Dashboard</Typography>
        </Box>
        {error && <Alert severity="error" sx={{ mb: 2, bgcolor: 'rgba(244,67,54,0.1)', color: '#f44336' }}>{error}</Alert>}
        <TextField
          fullWidth label="Логін" value={username}
          onChange={e => setUsername(e.target.value)}
          onKeyPress={e => e.key === 'Enter' && handleLogin()}
          sx={{ mb: 2, input: { color: '#fff' }, label: { color: '#aaa' }, '& .MuiOutlinedInput-notchedOutline': { borderColor: '#333' } }}
        />
        <TextField
          fullWidth label="Пароль" type={showPass ? 'text' : 'password'} value={password}
          onChange={e => setPassword(e.target.value)}
          onKeyPress={e => e.key === 'Enter' && handleLogin()}
          InputProps={{ endAdornment: (
            <span onClick={() => setShowPass(!showPass)} style={{ cursor:'pointer', color:'#aaa', userSelect:'none', paddingRight:8 }}>
              {showPass ? '🙈' : '👁'}
            </span>
          )}}
          sx={{ mb: 3, input: { color: '#fff' }, label: { color: '#aaa' }, '& .MuiOutlinedInput-notchedOutline': { borderColor: '#333' } }}
        />
        {need2fa && (
          <Box sx={{ mb:2 }}>
            <Typography variant="body2" sx={{ color:'var(--ac1, #7c4dff)', mb:1 }}>🔐 Код з Google Authenticator:</Typography>
            <TextField fullWidth size="small" placeholder="000000" value={totpCode}
              onChange={e=>setTotpCode(e.target.value)}
              inputProps={{ maxLength:6, style:{letterSpacing:8,fontSize:20,textAlign:'center'} }}
              onKeyPress={e=>e.key==='Enter'&&handleLogin()}
              autoFocus
              sx={{ input:{color:'#fff'}, '& .MuiOutlinedInput-notchedOutline':{borderColor:'var(--ac1, #7c4dff)'} }}/>
          </Box>
        )}
        <Button fullWidth variant="contained" onClick={handleLogin} disabled={loading}
          sx={{ bgcolor: 'var(--ac1, #7c4dff)', py: 1.5, fontSize: 16, '&:hover': { bgcolor: '#6c3dff' } }}>
          {loading ? <CircularProgress size={24} sx={{ color: '#fff' }}/> : need2fa ? 'Підтвердити' : 'Увійти'}
        </Button>
      </Paper>
    </Box>
  );
}
